import React, { FormEvent, useState } from 'react';
import BaseLayer from 'ol/layer/Base';


export interface BgisBasemapProps {
  id: string,
  label: string;
  icon: string;
  layer: BaseLayer;
  tooltip?: string;
};

export interface BgisBasemapLayerProps extends BgisBasemapProps {
  toggleVisibility: () => {} ;
};


export const BgisBasemapLayer: React.FC<BgisBasemapLayerProps> = ({ id, icon, label, layer, tooltip, toggleVisibility }) => {



  return (
    <button key={id} className={`bgis-vt bgis-center${layer.getVisible() ? ' bgis-active' : ''}`} onClick={toggleVisibility}  >
      <img className='bgis-basemap-icon' width='40' height='40' src={icon} alt={tooltip}></img>
      <a className={`bgis-caption`}>{label}</a>
    </button>);
};

export interface BgisBasemapLayersProps {
  layers: BgisBasemapProps[]; // The available basemap layers.
}

export const BgisBasemapLayers: React.FC<BgisBasemapLayersProps> = ({ layers }) => {


  /** Get all basemapLayers as array */
  const baseLayers = layers.map(basemapLayer => basemapLayer.layer);

  const [activeLayer, setActiveLayer] = useState(baseLayers.find(layer => layer.getVisible()===true)); 

  /**
   * Toggles the visibility of the layer.
   * @returns false.
   */
   const toggleVisibility = (layer:BaseLayer) => {
    baseLayers.forEach(baseLayer => baseLayer.setVisible(baseLayer === layer));
    setActiveLayer(layer);
    return false;
  }


  return (<>{layers.map(baseLayer => (
    <BgisBasemapLayer id={baseLayer.id} icon={baseLayer.icon} label={baseLayer.label} layer={baseLayer.layer} toggleVisibility={() => toggleVisibility(baseLayer.layer)}></BgisBasemapLayer>
  ))}</>);
};
